module.exports = __webpack_public_path__ + "img/botella_black_6.95544b47.jpeg";